import asserts from '../asserts';

const tableHeaderFixed = (dom, top) => {
  const scrollHeight = window.pageYOffset;
  let headerDom = document.querySelectorAll(`.${dom} .ant-table-thead`);
  let firstRowList = document.querySelectorAll(`.${dom} .ant-table-row`);
  let firstRowTop = 0;
  if (firstRowList && Array.from(firstRowList).length) {
    firstRowTop = firstRowList[0].getBoundingClientRect().top;
  }
  // const standardHeight = headerDom[0].getBoundingClientRect().top;
  const headerHeight = headerDom[0].getBoundingClientRect().height;
  let firstRows = document.querySelector(`.${dom} .ant-table-tbody .ant-table-row:first-child`);
  // console.log(firstRows, 'firstRows');
  if (asserts.isExist(firstRows)) {
    let rowKey = firstRows.getAttribute('data-row-key');
    let tds = null;
    if (rowKey === '0') {
      // 满减行
      let rows = document.querySelectorAll(`.${dom} .ant-table-tbody .ant-table-row`);
      let secondRow = rows[1];
      if(secondRow){
        tds = secondRow.querySelectorAll('td');
      }
     
    } else {
      tds = document.querySelectorAll(`.${dom} .ant-table-tbody .ant-table-row:first-child td`);
    }
    let ths = document.querySelectorAll(`.${dom} .ant-table-thead  th`);
    if (firstRowTop <= headerHeight && tds.length && ths.length) {
      if (getComputedStyle(headerDom[0], null)['position'] !== 'fixed') {
        headerDom[0].style.position = 'fixed';
        headerDom[0].style.top = top;
        headerDom[0].style.zIndex = 100;
        ths.forEach((item, i) => {
          item.style.width = getComputedStyle(tds[i]).width;
          item.style.minWidth = getComputedStyle(tds[i]).width;
          item.style.maxWidth = getComputedStyle(tds[i]).width;
        });
      }
    } else {
      headerDom[0].removeAttribute('style');
      ths.forEach((item, i) => {
        item.style.width = undefined;
        item.style.minWidth = undefined;
        item.style.maxWidth = undefined;
      });
    }
    return;
  }
};
export default tableHeaderFixed;
